/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Candidates_TagInputs */

const vi_einvoice_candidates_tag = /** @type {(inputs: Einvoice_Candidates_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GỢI Ý`)
};

/**

* @param {Einvoice_Candidates_TagInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_candidates_tag = /** @type {((inputs?: Einvoice_Candidates_TagInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Candidates_TagInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_candidates_tag(inputs)
});